// Inline Lucide icons, extracted verbatim from react-icons/lu.
//
// react-icons ships each icon pack as ONE 624 kB module, so importing even a
// single icon pulls the entire pack — 11 icon references across 4 files were
// costing 1,934 kB of the main bundle, which no visitor pays for willingly.
// Tree-shaking cannot help: the icons are all functions inside one file.
//
// Path data is copied unchanged from the installed package, so these render
// pixel-identically. They size with font-size (1em) and inherit currentColor,
// which is what the existing CSS already relies on.
import React from "react";

export const LuSparkles = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"
      key={0}
    />
    <path d="M5 3v4" key={1} />
    <path d="M19 17v4" key={2} />
    <path d="M3 5h4" key={3} />
    <path d="M17 19h4" key={4} />
  </svg>
);

export const LuMoon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" key={0} />
    <path d="M19 3v4" key={1} />
    <path d="M21 5h-4" key={2} />
  </svg>
);

export const LuFlame = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"
      key={0}
    />
  </svg>
);

export const LuSprout = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M7 20h10" key={0} />
    <path d="M10 20c5.5-2.5.8-6.4 3-10" key={1} />
    <path
      d="M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z"
      key={2}
    />
    <path
      d="M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z"
      key={3}
    />
  </svg>
);

export const LuFlower2 = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1"
      key={0}
    />
    <circle cx="12" cy="8" r="2" key={1} />
    <path d="M12 10v12" key={2} />
    <path d="M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z" key={3} />
    <path d="M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z" key={4} />
  </svg>
);

export const LuOrbit = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <circle cx="12" cy="12" r="3" key={0} />
    <circle cx="19" cy="5" r="2" key={1} />
    <circle cx="5" cy="19" r="2" key={2} />
    <path d="M10.4 21.9a10 10 0 0 0 9.941-15.416" key={3} />
    <path d="M13.5 2.1a10 10 0 0 0-9.841 15.416" key={4} />
  </svg>
);

export const LuShield = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" key={0} />
    <path d="M12 8v4" key={1} />
    <path d="M12 16h.01" key={2} />
  </svg>
);

export const LuLeaf = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"
      key={0}
    />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" key={1} />
  </svg>
);

export const FaInfoCircle = (props) => (
  <svg
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path
      d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
      key={0}
    />
  </svg>
);

export const MdEdit = (props) => (
  <svg
    viewBox="0 0 24 24"
    height="1em"
    width="1em"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" key={0} />
    <path
      d="M12 22H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2v6h-2v-2H5v10h7v2zm10.13-5.01.71-.71a.996.996 0 0 0 0-1.41l-.71-.71a.996.996 0 0 0-1.41 0l-.71.71 2.12 2.12zm-.71.71-5.3 5.3H14v-2.12l5.3-5.3 2.12 2.12z"
      key={1}
    />
  </svg>
);
